import { useQuery } from '@tanstack/react-query'
import QueryState from '../query_state'
import { TextField } from '@cinesend/ui-kit'
import { useState } from 'react'
import useStore from '../../hooks/use_store'

const LocalizedLabels = ({ field }) => {
  const { data: labels, isLoading, isError, error } = useQuery([`field-labels`, `?fieldID=${field.id}`])
  const { data: languages } = useQuery([`languages?schemaId=${field.schema_id}`])

  if (!languages) {
    return null
  }

  return (
    <QueryState isLoading={isLoading} error={isError ? error : null}>
      <div className='flex items-center space-x-4'>
        {languages.map((language) => (
          <LocalizedLabel
            key={language.id}
            language={language}
            field={field}
            label={labels?.find((label) => language.id === label.language_id)}
          />
        ))}
      </div>
    </QueryState>
  )
}

const LocalizedLabel = ({ language, field, label }) => {
  const [value, setValue] = useState(label?.value)
  const { updateModel, createModel } = useStore()
  const updateLabel = (newValue) => {
    if (label) {
      updateModel.mutate({
        endpoint: `field-labels`,
        id: label.id,
        data: {
          value: newValue,
        },
      })
    } else {
      createModel.mutate({
        endpoint: `field-labels`,
        data: {
          field_id: field.id,
          language_id: language.id,
          value: newValue,
        },
      })
    }
  }
  return (
    <TextField
      label={`${language?.eng_description} label`}
      placeholder='Enter localized label here'
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={(e) => updateLabel(e.target.value)}
    />
  )
}

export default LocalizedLabels
